export default "__VITE_ASSET__d583d32a__"